<ion-app>
  <p-toast />
  <p-confirmdialog />
  <ion-router-outlet></ion-router-outlet>
</ion-app>